import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import Screen from '../../Components/Screen'
import { isAdmin, getTeamUrl } from 'Common'
import { createPermitFunction } from '../../Evolve/Utilities/permissions'

import Breadcrumbs from './Components/Breadcrumbs'
import Header from './Components/Header'
import Filters from './Components/Filters'
import Table from './Components/Table'

import User from '../../Modals/User'

type Props = {
  users: [],
  fetching: boolean,
  searchTerm: string,
  filters: {},
  pagination: {},
  userModal: boolean,
  userPermissions: [],
  componentDidMount: () => void,
  onChangeSearch: () => void,
  onSubmitSearch: () => void,
  onChangeFilter: () => void,
  onChangeTable: () => void,
  onClickRow: () => void,
  onClickExport: () => void,
  onClickNewUser: () => void,
  onCloseUserModal: () => void,
  didCreateUser: () => void,
  didUpdateUser: () => void,
  didDeleteUser: () => void,
  didDeactivateUser: () => void,
  didReactivateUser: () => void,
}

class Users extends React.PureComponent<Props> {

  componentDidMount = () => this.props.componentDidMount()

  render() {
    
    const {
      users,
      fetching,
      searchTerm,
      filters,
      pagination,
      userModal,
      userPermissions,
      onChangeSearch,
      onSubmitSearch,
      onChangeFilter,
      onChangeTable,
      onClickRow,
      onClickExport,
      onClickNewUser,
      onCloseUserModal,
      didCreateUser,
      didUpdateUser,
      didDeleteUser,
      didDeactivateUser,
      didReactivateUser,
    } = this.props

    // Permission check - redirect if user doesn't have access
    const permit = createPermitFunction(userPermissions)
    if (!isAdmin() || !permit('user_admin')) {
      return <Redirect to={getTeamUrl('')} />
    }
    
    return (

      <Screen>

        <Breadcrumbs />

        <Header
          searchTerm={searchTerm}
          onChangeSearch={onChangeSearch}
          onSubmitSearch={onSubmitSearch}
          onClickExport={onClickExport}
          onClickNewUser={onClickNewUser}
        />

        <Filters
          filters={filters}
          onChangeFilter={onChangeFilter}
        />

        <Table
          users={users}
          fetching={fetching}
          pagination={pagination}
          onChangeTable={onChangeTable}
          onClickRow={onClickRow}
        />

        {userModal.show && (
          <User
            id={userModal.id}
            onClose={onCloseUserModal}
            didCreate={didCreateUser}
            didUpdate={didUpdateUser}
            didDelete={didDeleteUser}
            didDeactivate={didDeactivateUser}
            didReactivate={didReactivateUser}
          />
        )}

      </Screen> 

    )

  }

}

const mapStateToProps = (state) => ({
  userPermissions: (state.user && state.user.permissions) || [],
})

export default connect(mapStateToProps)(Users)
